import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'ทุกอย่างเป็น PDF จริงๆ ไหม?',
  answer: 'ใช่ คุณจะได้รับทุกอย่างในรูปแบบ PDF ที่ดาวน์โหลดได้ทันทีหลังชำระเงิน สามารถพิมพ์หรือดูบนอุปกรณ์ใดก็ได้'
}, {
  question: 'เหมาะสำหรับประเภทการสอนของฉันไหม?',
  answer: 'ใช่ ระบบนี้ออกแบบสำหรับอาจารย์ฟุตบอล โค้ช และผู้ฝึกสอนทุกประเภท ทั้งในสโมสร โรงเรียน และอคาเดมีส่วนตัว'
}, {
  question: 'ต้องมีความรู้พิเศษไหม?',
  answer: 'ไม่ต้องเลย ระบบนี้ออกแบบมาสำหรับอาจารย์ที่ไม่มีการฝึกอบรมเฉพาะทาง เครื่องมือทุกชิ้นอธิบายตัวเองได้และพร้อมใช้ทันที'
}, {
  question: 'จะได้รับสื่อการสอนเมื่อไหร่?',
  answer: 'ทันทีหลังชำระเงิน คุณจะได้รับอีเมลพร้อมลิงก์ดาวน์โหลดภายใน 60 วินาที'
}, {
  question: 'ถ้าไม่พอใจทำอย่างไร?',
  answer: 'คุณมีการรับประกัน 7 วันเต็ม ถ้าไม่พอใจเราคืนเงินทุกบาทโดยไม่ถามคำถาม'
}, {
  question: 'ทำไมถึงราคาถูกขนาดนี้?',
  answer: 'เพราะเป็นสินค้าดิจิทัล ไม่มีค่าพิมพ์ ไม่มีค่าส่ง ไม่มีที่ปรึกษา ประหยัดที่ไหนเราส่งให้คุณ'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-cream-bg py-12 md:py-20 px-4 md:px-6" data-id="element-84">
      <div className="max-w-4xl mx-auto" data-id="element-85">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-center text-navy-primary mb-8 md:mb-12" data-id="element-86">
          คำถามที่พบบ่อย
        </motion.h2>

        <div className="space-y-3 md:space-y-4" data-id="element-87">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-88">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 md:p-6 text-left hover:bg-gray-50 transition-colors" aria-expanded={openIndex === index} data-id="element-89">
                <span className="font-bold text-navy-primary text-base md:text-lg pr-4" data-id="element-90">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="flex-shrink-0" data-id="element-91">
                  <ChevronDown className="w-5 h-5 md:w-6 md:h-6 text-gold-accent" data-id="element-92" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-93">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-94">
                    <div className="px-5 md:px-6 pb-5 md:pb-6 text-sm md:text-base text-gray-700 leading-relaxed" data-id="element-95">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}